export const PLANT_PALETTE: string[] = [
  "oklch(0.55 0.09 145)",
  "oklch(0.58 0.10 150)",
  "oklch(0.52 0.07 140)",
  "oklch(0.55 0.09 130)",
  "oklch(0.50 0.08 160)",
];

export function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}
